import React, { useEffect, useState } from "react";
import Card from "../components/Card";
import Button from "../components/Button";
import Input from "../components/Input";
import API from "../api/api";

export default function Perfil() {
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({
    nombre: "",
    email: "",
    role: "",
  });

  const ROLE_LABELS = {
    cliente: "Cliente — Publica y vende",
    comprador: "Comprador — Entidad financiera",
    admin: "Administrador del sistema",
  };

  const cargarPerfil = async () => {
    try {
      const res = await API.get("/perfil/");
      setForm(res.data);
    } catch (err) {
      console.error("Error cargando perfil:", err);
      alert("Error al cargar tu perfil.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarPerfil();
  }, []);

  const handleSave = async () => {
    if (!form.nombre) {
      alert("El nombre no puede estar vacío.");
      return;
    }

    try {
      await API.put("/perfil/editar/", {
        nombre: form.nombre,
      });

      alert("Perfil actualizado correctamente.");
    } catch (err) {
      console.error("Error actualizando perfil:", err);
      alert("No se pudo actualizar tu perfil.");
    }
  };

  if (loading) {
    return (
      <p className="text-center text-primary mt-10">
        Cargando perfil...
      </p>
    );
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-primary">Mi Perfil</h1>
      <p className="text-slate-600">Gestiona tus datos personales.</p>

      <Card className="space-y-4">
        <h2 className="text-xl font-semibold text-primary">
          Datos personales
        </h2>

        <Input
          label="Nombre completo"
          value={form.nombre}
          onChange={(e) =>
            setForm({ ...form, nombre: e.target.value })
          }
        />

        <div className="flex flex-col gap-1">
          <label className="text-sm font-medium">Email</label>
          <input
            className="border rounded p-2 bg-slate-100 text-slate-500"
            value={form.email}
            disabled
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-sm font-medium">Tipo de cuenta</label>
          <input
            className="border rounded p-2 bg-slate-100 text-slate-500"
            value={ROLE_LABELS[form.role] || "Rol desconocido"}
            disabled
          />
        </div>

        <Button className="w-full mt-2" onClick={handleSave}>
          Guardar cambios
        </Button>
      </Card>
    </div>
  );
}
